import gql from 'graphql-tag';

export class HeroSectionFragments {
  static body = gql`
    fragment DealroomHeroSectionFragment on DealroomHeroSection {
      id
      text
      meetTeamText
      media {
        ... on HeroSectionMediaImage {
          type
          imageId
          fullWidth
          imageSize
        }
        ... on HeroSectionMediaVideo {
          type
          videoId
          fullWidth
        }
      }
      background {
        type
        gradientColorOne
        gradientColorTwo
        gradientLightness
        imageId
      }
      layout
      layoutOrder
      textWidgetBackgroundColor
      fields {
        id
        mergeKey
        category
      }
      showLogo
    }
  `;
}
